import React, { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from '@components-library/Tooltip';
import cn from 'classnames';
import { UserAvatar } from 'components/shared/userAvatar';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { getPersonalDetails } from './getPersonalDetails';
import styles from './styles.module.scss';

export const UserSocialProfile = observer(() => {
  const { accountStore } = useMobxStore();
  const { userInfo, userProfile } = accountStore;

  const textRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);

  const { avatar, userInitials, fullName, nickname } = getPersonalDetails(userInfo, userProfile);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    if (textRef.current && divRef.current)
      if (textRef.current?.offsetWidth > divRef.current?.offsetWidth) {
        setIsTruncated(true);
      } else {
        setIsTruncated(false);
      }
  }, [fullName]);

  return (
    <div className={styles.socialProfile}>
      <UserAvatar
        className={styles.socialProfile__avatar}
        avatarSource={avatar}
        userInitials={userInitials}
        size={72}
      />
      <div className={styles.socialProfileInfoWrapper}>
        <Tooltip
          className={styles.socialProfile__tooltip}
          placement="top"
          open={isTruncated ? undefined : false}
          content={fullName}>
          <div ref={divRef} className={cn(styles.socialProfile__name)}>
            <span ref={textRef}>{fullName}</span>
          </div>
        </Tooltip>
        <p className={styles.socialProfile__nickname}>{nickname}</p>
      </div>
    </div>
  );
});
